import React from 'react';
import { FormContainer, SectionTitle, SectionSubtitle, GridContainer, SectionDivider, SubSectionTitle, GridThreeContainer } from './Styles';
import FormField from './FormField';
import SelectField from './SelectField';

export default function GuardianDetailsStep({ errors, touched, values, setFieldValue }) {
    const handleSelectChange = (fieldName) => (event) => {
        setFieldValue(fieldName, event.target.value);
    };

    const relationOptions = [
        { value: 3, label: 'Brother' },
        { value: 4, label: 'Sister' },
        { value: 1, label: 'Uncle' },
        { value: 2, label: 'Aunt' },
        { value: 5, label: 'Friend' },
    ];

    return (
        <FormContainer>
            <SectionTitle>Guardian Details</SectionTitle>
            <SectionSubtitle>
                Please provide details of your parents and guardian. All fields are optional.
                {values.fatherName || values.motherName || values.guardianName ?
                    ' Required fields are marked with * when a name is entered.' : ''}
            </SectionSubtitle>

            {/* Father's Section */}
            <SectionDivider>
                <SubSectionTitle>Father's Details
                    {/* <span style={{ fontSize: '12px', fontWeight: 'normal', color: '#6b7280' }}>(Optional)</span> */}
                </SubSectionTitle>
            </SectionDivider>

            <GridThreeContainer>
                <FormField
                    name="fatherName"
                    label="Father's Name"
                    type="text"
                    required
                    placeholder="Enter father's name"
                    error={errors.fatherName}
                    touched={touched.fatherName}
                />

                <FormField
                    name="fatherPhone"
                    label="Father's Mobile Number"
                    type="tel"
                    placeholder="Enter 10-digit mobile number"
                    maxLength="10"
                    required
                    error={errors.fatherPhone}
                    touched={touched.fatherPhone}
                />

                <FormField
                    name="fatherEmail"
                    label="Father's Email"
                    type="email"
                    placeholder="Enter father's email"
                    // required
                    error={errors.fatherEmail}
                    touched={touched.fatherEmail}
                />
            </GridThreeContainer>

            {/* Mother's Section */}
            <SectionDivider>
                <SubSectionTitle>Mother's Details <span style={{ fontSize: '12px', fontWeight: 'normal', color: '#6b7280' }}>(Optional)</span></SubSectionTitle>
            </SectionDivider>

            <GridThreeContainer>
                <FormField
                    name="motherName"
                    label="Mother's Name"
                    type="text"
                    placeholder="Enter mother's name"
                    error={errors.motherName}
                    touched={touched.motherName}
                />

                <FormField
                    name="motherPhone"
                    label="Mother's Mobile Number"
                    type="tel"
                    placeholder="Enter 10-digit mobile number"
                    maxLength="10"
                    required={!!values.motherName}
                    error={errors.motherPhone}
                    touched={touched.motherPhone}
                />

                <FormField
                    name="motherEmail"
                    label="Mother's Email"
                    type="email"
                    placeholder="Enter mother's email"
                    // required={!!values.motherName}
                    error={errors.motherEmail}
                    touched={touched.motherEmail}
                />
            </GridThreeContainer>

            {/* Guardian Section */}
            <SectionDivider>
                <SubSectionTitle>Other Guardian Details <span style={{ fontSize: '12px', fontWeight: 'normal', color: '#6b7280' }}>(Optional)</span></SubSectionTitle>
            </SectionDivider>

            <GridContainer>
                <FormField
                    name="guardianName"
                    label="Guardian's Name"
                    type="text"
                    placeholder="Enter guardian's name"
                    error={errors.guardianName}
                    touched={touched.guardianName}
                />

                <SelectField
                    name="guardianRelation"
                    label="Guardian's Relation"
                    value={values.guardianRelation}
                    onChange={handleSelectChange('guardianRelation')}
                    options={relationOptions}
                    placeholder="Select Relation"
                    required={!!values.guardianName}
                    error={errors.guardianRelation}
                    touched={touched.guardianRelation}
                />

                <FormField
                    name="guardianPhone"
                    label="Guardian's Mobile Number"
                    type="tel"
                    placeholder="Enter 10-digit mobile number"
                    maxLength="10"
                    required={!!values.guardianName}
                    error={errors.guardianPhone}
                    touched={touched.guardianPhone}
                />

                <FormField
                    name="guardianEmail"
                    label="Guardian's Email"
                    type="email"
                    placeholder="Enter guardian's email"
                    error={errors.guardianEmail}
                    touched={touched.guardianEmail}
                />
            </GridContainer>

            {/* Helper text showing required fields */}
            {/* {(values.fatherName || values.motherName || values.guardianName) && (
                <div style={{
                    marginTop: '20px',
                    padding: '12px',
                    backgroundColor: '#fef3c7',
                    borderRadius: '8px',
                    border: '1px solid #f59e0b',
                    fontSize: '14px',
                    color: '#92400e'
                }}>
                    <strong>Note:</strong>
                    {values.fatherName && ' Father\'s phone is required.'}
                    {values.motherName && ' Mother\'s phone is required.'}
                    {values.guardianName && ' Guardian\'s relation and phone are required.'}
                </div>
            )} */}
        </FormContainer>
    );
}